import dayjs from 'dayjs';

import { PAYMENT_STATES } from 'utilities/constants';

export const deduplicateScheduledPayments = (
  pastPayments,
  scheduledPayments,
) => {
  if (!pastPayments?.length || !scheduledPayments?.length) {
    return scheduledPayments ?? [];
  }

  const normalizeDate = (date) => dayjs(date).format('YYYY-MM-DD');

  const executedPaymentKeys = new Map();
  pastPayments.forEach((p) => {
    if (p.type && p.type !== PAYMENT_STATES.RETURNED) {
      const key = `${normalizeDate(p.date)}_${p.amount}`;
      executedPaymentKeys.set(key, (executedPaymentKeys.get(key) ?? 0) + 1);
    }
  });

  return scheduledPayments.filter((payment) => {
    const key = `${normalizeDate(payment.date)}_${payment.amount}`;
    const count = executedPaymentKeys.get(key);
    if (count > 0) {
      executedPaymentKeys.set(key, count - 1);
      return false;
    }
    return true;
  });
};

export const updatePaymentsWithPaymentState = (payments, accountPayments) => {
  const accountPaymentsByReference = accountPayments.reduce((acc, payment) => {
    // ach and debit payment transaction ids will always be 10 digits
    // but reference ids from cc-transactions can sometimes be prepended by many zeroes
    const reference = payment.reference.substring(
      payment.reference.length - 10,
    );
    acc[reference] = payment;
    return acc;
  }, {});

  const updatedPayments = payments?.map((payment) => {
    const matchingAccountPayment = accountPaymentsByReference[payment.txId];
    if (payment.type === PAYMENT_STATES.RETURNED) {
      return payment;
    }
    if (matchingAccountPayment) {
      return { ...payment, type: matchingAccountPayment.state };
    }
    return payment;
  });

  return updatedPayments;
};
